import { matchesEnvironment } from 'utils/config';

const isProductionEnv = () =>
  matchesEnvironment('uat') ||
  matchesEnvironment('passport') ||
  matchesEnvironment('production');

const matchesAllowedUrl = (
  hostname: string,
  allowedUrls: string[],
): boolean => {
  // Exact match
  if (allowedUrls.includes(hostname)) {
    return true;
  }

  // Wildcard subdomain match (review/dev/ci/stage only): strip the first subdomain
  // segment and check if the parent hostname is in the allowlist.
  // e.g. 'numbers-history-app-dev-{tag}.dev.dashboard.bandwidth.com' → 'dev.dashboard.bandwidth.com'
  const parentHostname = hostname.split('.').slice(1).join('.');
  return parentHostname.length > 0 && allowedUrls.includes(parentHostname);
};

const allowReturnToUrl = (url: URL) => {
  const { hostname } = url;

  if (isProductionEnv()) {
    return window._config?.allowedReturnToUrls.includes(hostname) || false;
  }
  const allowedUrls = window._config?.allowedReturnToUrls ?? [];
  return matchesAllowedUrl(hostname, allowedUrls);
};

export default allowReturnToUrl;
